import { V4_ENABLED } from 'views/TradingCompetitionV4/config'

/**
 * The public competition URLs. No version numbers: one route, /trading-competition. The V3 contract's competitions live under /legacy; the old
 * /trading-competition-v3/* and /-v4/* URLs redirect here (next.config.mjs). Without the V4 contract configured the old paths stay as they were.
 */
export const COMPETITIONS = V4_ENABLED ? '/trading-competition' : '/trading-competition-v3'
export const CREATE = V4_ENABLED ? '/trading-competition/create' : '/trading-competition-v3/create'
export const LOCK_CLAIM = V4_ENABLED ? '/trading-competition/lock-claim' : '/trading-competition-v3/lock-claim'
export const REFERRAL = V4_ENABLED ? '/trading-competition/referral' : '/trading-competition-v3/referral'
/** a competition of the current contract */
export const competitionPath = (id: number | string) => (V4_ENABLED ? `/trading-competition/${id}` : `/trading-competition-v3/${id}`)
/** a competition of the previous (V3) contract, shown with a small "legacy" tag */
export const legacyPath = (id: number | string) => (V4_ENABLED ? `/trading-competition/legacy/${id}` : `/trading-competition-v3/${id}`)
